import { useEffect } from "react";
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation, useRouteMatch } from "react-router-dom";
import { getEducationArticle, updateEducationArticle } from "../../../api/homepageManagementEducationInfo.api";
import ErrorResponse from "../../../components/ErrorResponse";
import EducationEditor from "../../../components/homepage/education/Editor";
import SimpleHeader from "../../../components/layout/SimpleHeader";
import Loader from "../../../components/Loader";
import useAxios from "../../../hooks/useAxios";
import useNotification from "../../../hooks/useNotification";
import { IGetEducationArticle } from "../../../models/homepageManagementEducationInfo.model";

interface IMatch {
  bulletinCode: string;
}

const HomepageEducationEdit = () => {
  const { t } = useTranslation();
  const match = useRouteMatch<IMatch>();
  const bulletinCode = Number(match.params.bulletinCode);
  const history = useHistory();
  const location = useLocation();
  const { successNotification } = useNotification();
  const { data: res, isLoading, error, execute } = useAxios<IGetEducationArticle>();
  const { data: submitRes, isLoading: submitIsLoading, error: submitError, execute: submitExecute } = useAxios();

  useEffect(() => {
    if (bulletinCode) {
      execute(getEducationArticle(bulletinCode));
    }
  }, [bulletinCode]);

  useEffect(() => {
    if (submitRes && !submitIsLoading) {
      successNotification(t('common.message.save1'));
      history.push(`/homepage/education${location.search}`);
    }
  }, [submitRes, submitIsLoading]);

  const submit = (data: FormData) => {
    if (!bulletinCode) return;
    submitExecute(updateEducationArticle(bulletinCode, data));
  }

  return (
    <div className="content scrollbar">
      {isLoading || submitIsLoading ? <Loader /> : null}
      <ErrorResponse error={error} />
      <ErrorResponse error={submitError} />
      <SimpleHeader
        iconFile="icon-homepage-big.svg"
        parentMenu={t('common.menu.homepage')}
        currentMenu={t('homepage.education.title4')}
      />
      <EducationEditor
        data={res?.data}
        submit={submit}
      />
    </div>
  );
}

export default HomepageEducationEdit;
